var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.c千円表示フラグ !== null)?_c('span',[_vm._v(" 単位： "),_c('elw-enum-select',{attrs:{"enum":_vm.e千円表示フラグ,"value":_vm.c千円表示フラグ},on:{"update:value":function($event){_vm.c千円表示フラグ=$event}}}),_vm._v(" （"+_vm._s(_vm.経理方式Label)+"） ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }